class DlPageGiveawayM extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.container = this.querySelector('.dl-page-giveaway-m-container');
        this.id = this.dataset.dlId;
        this.btn = this.querySelector('.dl-page-giveaway-form-button[name="submit_email"]');
        this.input = this.querySelector('.dl-page-giveaway-form-input[name="email"]');
        this.errorMessage = this.querySelector('.dl-page-giveaway-form-error-message');
        this.pop = this.querySelector('dl-pop-base-v2');
        this.yesBtn = this.querySelector('.dl-page-giveaway-pop-button-main');
        this.noBtn = this.querySelector('.dl-page-giveaway-pop-button-minor');
        this.eventName = this.dataset.dlEventName;
        this.popQuestionEventName = this.querySelector('.dl-page-giveaway-pop-question').dataset.eventName;
        this.storageKey = `dl-giveaway-submitted-${this.id}`;
        this.bindEvents();
    }
    bindEvents() {
        this.btn.addEventListener('click', this.btnClick.bind(this));
        this.yesBtn.addEventListener('click', this.yesBtnClick.bind(this));
        this.noBtn.addEventListener('click', this.noBtnClick.bind(this));
    }

    async yesBtnClick() {
        DLPixelH.addToUserArrayProperty(`${this.popQuestionEventName}-feedback`, 'yes');
        DLPixelH.capture(this.popQuestionEventName, {
            "feedback": "yes"
        });
        this.pop?.hide();
    }

    async noBtnClick() {
        DLPixelH.addToUserArrayProperty(`${this.popQuestionEventName}-feedback`, 'no');
        DLPixelH.capture(this.popQuestionEventName, {
            "feedback": "no"
        });
        this.pop?.hide();
    }

    async btnClick() {
        let email = this.input.value.trim();
        if (email === '') {
            this.errorMessage.classList.add('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = this.errorMessage.dataset.errorMessage;
            return;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValid = emailRegex.test(email) && email.length <= 128;
        if (!isValid) {
            this.errorMessage.classList.add('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = this.errorMessage.dataset.errorMessage;
            return;
        }
        const submittedEmail = localStorage.getItem(this.storageKey);
        if (submittedEmail && submittedEmail === email.toLowerCase()) {
            this.errorMessage.classList.add('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = this.errorMessage.dataset.duplicateMessage || 'This email has already been submitted.';
            return;
        }
        if (typeof braze === 'undefined' || !braze) {
            this.input.classList.add('dl-error');
            this.errorMessage.classList.add('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = 'Please try again later';
            return;
        }
        try {
            DLPixelH.addToUserArrayProperty('page-subscribed', `${this.id}`);
            DLPixelH.identify(email);
            let braze_lastest_shopify_store = localStorage.getItem('braze_lastest_shopify_store');
            if (!braze_lastest_shopify_store) {
                let subdomain = window.location.hostname.split('.')[0];
                subdomain = subdomain == 'petlibro' || subdomain == 'ca' ? 'us' : subdomain;
                localStorage.setItem('braze_lastest_shopify_store', subdomain);
            }
            let data = {};
            data["page-subscribed"] = `${this.id}`;
            data["email"] = email;
            data["shopify_store"] = braze_lastest_shopify_store;
            DLPixelH.capture(this.eventName, data);
        }
        catch (error) {
            this.input.classList.add('dl-error');
            this.errorMessage.classList.add('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = 'Please try again later';
            return;
        }
        finally {
            this.input.classList.remove('dl-error');
            this.errorMessage.classList.remove('dl-show');
            this.errorMessage.querySelector('.dl-page-giveaway-form-error-message-text').textContent = '';
            this.input.value = '';
        }
        localStorage.setItem(this.storageKey, email.toLowerCase());
        this.pop?.show();
    }
}
customElements.define('dl-page-giveaway-m', DlPageGiveawayM);